import {useMutation} from 'react-query';

export const useGatedMutation = (mutationFn, options = {}) => {
  const authDetails = JSON.parse(localStorage.getItem('state'))?.auth;
  const isGated = authDetails?.userDetails?.company?.id;
  return useMutation(
    (...args) => {
      if (!isGated) {
        return Promise.resolve(null);
      }
      return mutationFn(...args);
    },
    {
      ...options,
    },
  );
};
